// extracted by mini-css-extract-plugin
export default {"place":"_Hobbies_place__I03jN","place__img":"_Hobbies_place__img__Txnmw","place__description":"_Hobbies_place__description__6ARvF"};